/**
 * PM CRM utilities that were formerly bundled with typeahead.
 * Typeahead itself is now in the shared SeeMe bundle.
 */

import { selectComboboxOption } from './combobox-inline-create.js';

/**
 * Quick date picker for create forms.
 * Used by PM CRM lead create sheet (and similar).
 * Buttons: <button onclick="pickLeadQuickDate(this, 0)">Today</button>
 */
window.pickLeadQuickDate = function (btn, days) {
    btn.classList.add('chip-active');
    setTimeout(function () { btn.classList.remove('chip-active'); }, 300);
    var dateInput = document.getElementById('create-next-action-date');
    if (!dateInput) return;
    var d = new Date();
    d.setDate(d.getDate() + days);
    dateInput.value = d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0');
};

/**
 * Inline affiliate creation from referrer combobox.
 * Listens for combobox:add event, POSTs to create endpoint,
 * injects new option into the list and selects it.
 */
document.addEventListener('combobox:add', function (e) {
    var combobox = e.target.closest('[data-combobox]');
    if (!combobox) return;
    var createUrl = combobox.getAttribute('data-create-url');
    if (!createUrl) return;
    var name = (e.detail.query || '').trim();
    if (!name) return;

    var csrfToken = window._cc && window._cc.getCsrfToken ? window._cc.getCsrfToken() : '';

    var xhr = new XMLHttpRequest();
    xhr.open('POST', createUrl);
    xhr.setRequestHeader('X-CSRFToken', csrfToken);
    xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
    xhr.onload = function () {
        if (xhr.status !== 200) {
            if (window.SeeMe && window.SeeMe.toast) window.SeeMe.toast.error('Failed to create');
            return;
        }
        var data = JSON.parse(xhr.responseText);

        // Inject the new option into the list and select it
        selectComboboxOption(combobox, data.id, data.name);

        if (window.SeeMe && window.SeeMe.toast) {
            window.SeeMe.toast.success('Referrer created');
        }
    };
    xhr.send('name=' + encodeURIComponent(name));
});
